// IN|STALROS i18n translations — ES (primary), EN, FR, PT
export const translations = {
  es: {
    nav: {
      products: "Tecnologías",
      atlas: "ATLAS System",
      sygnal: "Sygnal Shield",
      integrations: "Integraciones",
      sectors: "Sectores",
      armor: "Blindaje Electrónico",
      forensic: "Forense Digital",
      footprint: "Presencia Global",
      portal: "Centro de Cliente",
      login: "Iniciar Sesión",
      logout: "Cerrar Sesión",
      dashboard: "Dashboard",
      sygnalPage: "Sygnal Shield",
      safelinkPage: "SafeLink",
      vault: "Sygnal Vault",
      inbox: "Inquiries Inbox",
      platforms: "Plataformas",
    },
    platforms: {
      directory: "Directorio de plataformas",
      tenant: "cliente",
      tenants: "clientes",
      cargillDesc: "Plataforma ATLAS operativa · Producción",
      onboardTitle: "¿Tu plataforma dedicada?",
      onboardDesc: "Solicita un tenant privado para tu organización",
    },
    landing: {
      eyebrow: "Inteligencia de Seguridad Integrada",
      heroTitle: "Elevando los Estándares de Seguridad e Integración Industrial",
      heroSubtitle:
        "Soluciones integrales de inteligencia operativa y protección de activos a nivel global. Diseñamos, integramos y sostenemos la columna vertebral tecnológica de operaciones críticas en LATAM y Norteamérica. Inventores y creadores de ATLAS y Sygnal Shield.",
      ctaPrimary: "Acceder al Centro de Cliente",
      ctaSecondary: "Explorar tecnologías",
      stat1: "Sitios protegidos",
      stat2: "Operaciones 24/7",
      stat3: "Integraciones nativas",
      stat4: "Países activos",
      productsEyebrow: "Ecosistema Propietario",
      productsTitle: "Tres pilares para una postura de seguridad única",
      atlasTitle: "ATLAS System: Control Operacional e Inteligencia de Activos",
      atlasDesc:
        "Gestión de mantenimiento y trazabilidad industrial mediante tecnología NFC, sin dependencia de conectividad constante.",
      atlasFeat1: "Trazabilidad NFC: identificación inequívoca de cada activo en campo",
      atlasFeat2: "Checklists Inteligentes: procesos claros y seguros con evidencia digital",
      atlasFeat3: "Análisis Predictivo: detecta fallas antes de paros operativos",
      atlasFeat4: "Eficiencia Real: −30% costos operativos · +99% visibilidad de mantenimiento",
      sygnalTitle: "Sygnal Shield",
      sygnalDesc:
        "Protección electromagnética y seguridad de espectro para infraestructuras donde una señal comprometida no es una opción.",
      sygnalFeat1: "Blindaje EMC/EMP",
      sygnalFeat2: "Monitoreo de Espectro",
      sygnalFeat3: "Hardening RF",
      integTitle: "Integraciones a Medida",
      integDesc:
        "Infraestructura física, radar perimetral y control de acceso biométrico — orquestados como un único sistema operativo de seguridad.",
      integFeat1: "Radar Magos",
      integFeat2: "Biometría Kantech / Lenel",
      integFeat3: "Infraestructura física",
      safelinkEyebrow: "Seguridad de Proximidad IoT",
      safelinkTitle: "SafeLink UA350: Prevención Activa de Colisiones IoT",
      safelinkDesc:
        "Sistema de alerta de proximidad basado en tecnología UWB (Ultra-Wideband) que juzga el nivel de peligro por distancia en tiempo real. Localización inalámbrica de alta fidelidad de 0 a 100 metros, base IP65, brazaletes IP67 y sirena integrada de 100 dB para entornos de alto ruido industrial.",
      safelinkFeat1: "Precisión UWB · 0–100 m de alcance",
      safelinkFeat2: "Estación Base IP65 · Brazalete IP67",
      safelinkFeat3: "Sirena integrada 100 dB ajustables",
      sygnalCardEyebrow: "Línea de accesorios · Sygnal Shield",
      sygnalCardTitle: "Sygnal Shield Card Sleeve: Blindaje Electromagnético Portátil",
      sygnalCardDesc:
        "Protección avanzada para tarjetas RFID y NFC. Actúa como una jaula de Faraday portátil, bloqueando cualquier intento de lectura no autorizada o clonación de credenciales de acceso corporativo.",
      sygnalCardFeat1: "Bloqueo total NFC, RFID HF y RFID UHF",
      sygnalCardFeat2: "Cumple BCRA Resolución A 7724 · ISO/IEC 14443",
      sygnalCardFeat3: "ASTM D1894 · uso diario sin degradación del blindaje",
      sygnalCardCta: "Conocer la línea Sygnal",
      trustEyebrow: "Social Proof",
      trustTitle: "Respaldado por Líderes Globales",
      trustDesc:
        "Nuestras soluciones de integración inteligente operan en las infraestructuras más críticas de múltiples empresas en LATAM y Norteamérica.",
      radarEyebrow: "Detección Perimetral",
      radarTitle: "Soluciones de Radar de Grado Militar",
      radarDesc:
        "Detección perimetral de largo alcance y alta precisión. Integración nativa para monitoreo 24/7 sin importar las condiciones climáticas o de iluminación.",
      radarFeat1: "Largo alcance con resolución submétrica",
      radarFeat2: "Operación 24/7 todas las condiciones climáticas",
      radarFeat3: "Integración nativa C&C ATLAS",
      radarFeat4: "Cobertura 360° configurable por sector",
      footprintEyebrow: "Presencia Global",
      footprintTitle: "Operamos donde la confiabilidad no es negociable",
      ctaTitle: "¿Listo para una operación con visibilidad total?",
      ctaDesc:
        "Accede al Centro de Comando IN|STALROS y orquesta tus tecnologías ATLAS, Sygnal Shield e integraciones desde un único panel.",
      sectorsEyebrow: "Sectores Críticos",
      sectorsTitle: "Donde una falla no es opción",
      sectorsDesc:
        "Diseñamos posturas de seguridad calibradas para los sectores donde la disponibilidad y la integridad de la operación son la línea de negocio.",
      sectorPortsTitle: "Puertos & Aeropuertos",
      sectorPortsDesc:
        "Vigilancia perimetral, control de muelles y pistas, AI Video Analytics para detección de intrusión y trazabilidad operacional.",
      sectorOilTitle: "Oil & Gas — Refinerías",
      sectorOilDesc:
        "Protección de instalaciones ATEX, monitoreo térmico y detección temprana de eventos en plantas de proceso y poliductos.",
      sectorMiningTitle: "Minería",
      sectorMiningDesc:
        "Operaciones remotas en altura, control de acceso biométrico para túneles y radar perimetral en pits y rajos abiertos.",
      sectorGovTitle: "Infraestructura Gubernamental",
      sectorGovDesc:
        "Edificios estratégicos, fronteras y prisiones — soluciones C&C con cumplimiento, blindaje electrónico y cadena de custodia.",
      armorEyebrow: "Blindaje Estratégico",
      armorTitle: "Electronic Armor & Signal Shielding",
      armorDesc:
        "Extendemos las capacidades físicas de Sygnal Shield con un portafolio de hardware: jaulas de Faraday a medida, gabinetes TEMPEST, blindajes EMP/HEMP, ventanas RF, y enclosures clase militar para cuartos de servidores y salas SCIF.",
      armorPoint1: "Jaulas de Faraday & gabinetes TEMPEST",
      armorPoint2: "Atenuación EMP / HEMP de hasta 100 dB",
      armorPoint3: "Salas SCIF certificadas",
      armorPoint4: "Ventanas y puertas RF blindadas",
      forensicEyebrow: "Forense Digital",
      forensicTitle: "Forensic Informatics & Digital Investigations",
      forensicDesc:
        "Equipo especializado en informática forense con experiencia consolidada en los mercados argentino y chileno. Adquisición y análisis bajo cadena de custodia, peritajes judiciales, recuperación de evidencia digital y respuesta a incidentes.",
      forensicPoint1: "Adquisición forense (FTK, EnCase, X-Ways)",
      forensicPoint2: "Cadena de custodia certificada",
      forensicPoint3: "Peritajes judiciales AR / CL",
      forensicPoint4: "Respuesta a incidentes (DFIR) 24/7",
      showcaseEyebrow: "IN|STALROS en acción",
      showcaseTitle: "Operaciones reales, evidencia visual",
      showcaseDesc:
        "Mira cómo desplegamos ATLAS, Sygnal Shield e integraciones en sitios críticos de LATAM y Norteamérica. Un recorrido por la profundidad de campo, los casos de uso y los resultados operacionales.",
      showcaseTag: "Showcase · 2026",
    },
    sygnal: {
      eyebrow: "Producto Propietario · Sygnal Shield",
      heroTitle: "Invisibles Electrónicamente",
      heroSubtitle: "Donde la información sensible debe permanecer dentro, y todo lo demás afuera. Sygnal Shield es nuestro ecosistema propietario de blindaje electromagnético: jaulas de Faraday, gabinetes TEMPEST, salas SCIF y carpas tácticas para operaciones de campo.",
      ctaPrimary: "Solicitar Auditoría de Espectro",
      ctaSecondary: "Descargar dossier técnico",
      mapTitle: "Diagnóstico en vivo · Cómo bloqueamos el espectro",
      mapDesc: "Las señales GSM, LTE, 5G, WiFi, Bluetooth y GPS son atenuadas hasta 100 dB en el perímetro Sygnal Shield. Lo que entra al perímetro, no llega adentro. Lo que se procesa adentro, no se filtra afuera.",
      featuresEyebrow: "Capacidades técnicas",
      featuresTitle: "Cuatro líneas de producto. Una sola filosofía: silencio electromagnético.",
      lineFaradayTitle: "Jaulas de Faraday Prefabricadas",
      lineFaradayDesc: "Salas modulares con atenuación certificada de 100 dB hasta 18 GHz. Despliegue rápido, integración con HVAC y control de acceso.",
      lineTempestTitle: "Gabinetes TEMPEST",
      lineTempestDesc: "Gabinetes 42U blindados, conformes a NSTISSAM TEMPEST/1-92 y NATO SDIP-27. Para procesamiento clasificado y SCIF Tier IV.",
      lineHempTitle: "Salas SCIF · EMP/HEMP",
      lineHempDesc: "Protección contra pulso electromagnético de gran altitud. Cumplimiento MIL-STD-188-125-1 y IEC 61000-2-9.",
      lineTacticalTitle: "Carpas Tácticas Sygnal SS-1",
      lineTacticalDesc: "Despliegue rápido en operaciones de campo y comando móvil. Aislamiento RF, ligero, plegable, certificado MIL-STD.",
      galleryEyebrow: "Galería técnica",
      galleryTitle: "El producto físico, el producto operativo",
      gal1: "Invisibles Electrónicamente — Filosofía de producto",
      gal2: "Jaulas de Faraday Prefabricadas en sitio cliente",
      gal3: "Sygnal SS-1 — Carpa táctica desplegada en operación",
      gal4: "Soluciones Sygnal Shield — Aplicaciones",
      useCasesEyebrow: "Casos de Uso",
      useCasesTitle: "Donde Sygnal Shield es la última línea de defensa",
      uc1Title: "Cuartos de Servidores Críticos",
      uc1Desc: "Aislar datos clasificados de fugas TEMPEST y emanaciones comprometidas.",
      uc2Title: "Operaciones DFIR de Campo",
      uc2Desc: "Adquirir evidencia digital sin contaminación de espectro ni fuga remota.",
      uc3Title: "Comando Móvil & Tactical Ops",
      uc3Desc: "Comunicaciones de mando aisladas en zonas hostiles o vigiladas.",
      uc4Title: "SCIF & Salas Clasificadas",
      uc4Desc: "Salas certificadas para reuniones y procesamiento de información clasificada.",
      specEyebrow: "Especificaciones",
      specTitle: "Performance medible, no marketing",
      specAttenuation: "Atenuación",
      specStandards: "Estándares",
      specRange: "Rango de frecuencia",
      specCustom: "Personalización",
      specAttenuationVal: "Hasta 100 dB",
      specStandardsVal: "MIL-STD-188-125 · IEEE 299 · NATO SDIP-27",
      specRangeVal: "9 kHz – 40 GHz",
      specCustomVal: "100% a medida del sitio",
      formEyebrow: "Auditoría de Espectro",
      formTitle: "Solicita una evaluación técnica para tu instalación",
      formDesc: "Nuestro equipo de ingeniería responde en 48 horas con un brief de viabilidad y dimensionamiento preliminar.",
      formName: "Nombre y apellido",
      formEmail: "Correo corporativo",
      formCompany: "Empresa / Organismo",
      formPhone: "Teléfono",
      formCountry: "País",
      formRequirements: "Requerimientos · perfil de amenaza",
      formRequirementsPh: "Tipo de instalación, sectores de amenaza, normativas aplicables...",
      formSubmit: "Enviar solicitud",
      formSending: "Enviando...",
      formSuccess: "Solicitud recibida. Nuestro equipo te contactará en menos de 48 horas.",
      formError: "No pudimos enviar tu solicitud. Reintenta en unos minutos.",
      formRateLimit: "Demasiadas solicitudes desde tu IP. Reintenta en una hora.",
      formCaptchaRequired: "Por favor completa la verificación captcha antes de enviar.",
      formCaptchaFailed: "La verificación captcha falló. Reintenta marcando la casilla.",
      vaultPromoTitle: "Acceso al Sygnal Shield Technical Vault",
      vaultPromoDesc: "Datasheets, reportes de cumplimiento y notas de firmware. Descarga restringida a clientes autenticados.",
      vaultPromoCta: "Acceder al Vault",
    },
    vault: {
      eyebrow: "Repositorio técnico · Restringido",
      title: "Sygnal Shield Technical Vault",
      subtitle: "Datasheets, reportes de cumplimiento, notas de firmware y playbooks operacionales para clientes Sygnal Shield.",
      filterAll: "Todos",
      filterFaraday: "Faraday",
      filterTempest: "TEMPEST",
      filterHemp: "EMP/HEMP",
      filterSpectrum: "Espectro",
      filterTactical: "Táctico",
      attenuation: "Atenuación",
      standards: "Estándares",
      version: "Versión",
      noItems: "Sin documentos en esta categoría.",
    },
    inbox: {
      eyebrow: "Bandeja de leads · Solo administradores",
      title: "Inquiries Inbox",
      subtitle: "Triaje de solicitudes globales de Sygnal Shield, ATLAS e integraciones. Responde dentro de 48h SLA.",
      filterAll: "Todas",
      filterNew: "Nuevas",
      filterContacted: "Contactadas",
      filterQualified: "Calificadas",
      filterClosed: "Cerradas",
      total: "Total",
      requirements: "Requerimientos",
      country: "País",
      company: "Empresa",
      phone: "Teléfono",
      received: "Recibido",
      markContacted: "Marcar contactada",
      markQualified: "Calificar",
      markClosed: "Cerrar",
      markNew: "Reabrir",
      noInquiries: "Sin solicitudes con este estado.",
      typeSygnal: "Sygnal Shield",
      typeAtlas: "ATLAS",
      typeIntegration: "Integración",
      typeForensic: "Forense",
      typeSafelink: "SafeLink",
      typeGeneral: "General",
    },
    safelink: {
      eyebrow: "Producto Propietario · SafeLink (UA350)",
      heroTitle: "SafeLink — Sistema de Alerta de Proximidad IoT (UWB)",
      heroSubtitle: "Solución avanzada IoT con Ultra-Wideband. SafeLink juzga el grado de peligro según la distancia en tiempo real, emitiendo alarmas sonoras y luminosas para prevenir colisiones entre vehículos y peatones en entornos industriales.",
      ctaPrimary: "Solicitar Estudio de Cobertura UWB",
      ctaSecondary: "Descargar Manual UA350",
      overviewEyebrow: "Arquitectura de Hardware",
      overviewTitle: "Tres elementos críticos. Una sola red UWB.",
      hwBaseTitle: "Estación Base UA350",
      hwBaseDesc: "Instalada horizontalmente en la parte superior o frontal del montacargas. Detección simultánea de hasta 30 brazaletes.",
      hwBaseSpecs: "IP65 · 12V–48V DC · 30 tags",
      hwBraceletTitle: "Brazalete SF202",
      hwBraceletDesc: "Recargable, uso en muñeca o casco. Vibración al ingresar a zonas de peligro y batería de hasta 23 días (8h/día).",
      hwBraceletSpecs: "IP67 · 23 días · vibración",
      hwAlarmTitle: "Luz de Alarma",
      hwAlarmDesc: "Señal visual y auditiva ajustable de 100 dB para advertir a los peatones aún a alta distancia.",
      hwAlarmSpecs: "100 dB · LED · ajustable",
      zonesEyebrow: "Zonas de Seguridad Configurables",
      zonesTitle: "Tres perímetros precisos, ajustables al centímetro",
      zone1Label: "ALARMA",
      zone1Title: "Zona de Alarma de Emergencia",
      zone1Desc: "Perímetro crítico de reacción inmediata. Activa luz, sirena y vibración.",
      zone1Range: "Ej. 0–5 m",
      zone2Label: "ALERTA",
      zone2Title: "Zona de Pre-alarma",
      zone2Desc: "Área de advertencia preventiva. Notifica al peatón y al operador.",
      zone2Range: "Ej. 5–10 m",
      zone3Label: "PRECAUCIÓN",
      zone3Title: "Zona sin Alarma",
      zone3Desc: "Área de operación segura. Sistema en monitoreo silencioso.",
      zone3Range: "Más de 10 m",
      specsEyebrow: "Especificaciones técnicas principales",
      specsTitle: "Performance medible, no marketing",
      specTech: "Tecnología de Red",
      specTechVal: "UWB · 3.25 – 6.75 GHz",
      specRange: "Rango Efectivo",
      specRangeVal: "0 – 100 m",
      specPrecision: "Precisión",
      specPrecisionVal: "UWB 802.15.4a · alta",
      specProtection: "Protección Ambiental",
      specProtectionVal: "Base IP65 · Brazalete IP67",
      specComm: "Comunicación auxiliar",
      specCommVal: "LoRa · 433 MHz",
      specPower: "Alimentación",
      specPowerVal: "12V – 48V DC",
      industriesEyebrow: "Industrias",
      industriesTitle: "Donde SafeLink salva vidas todos los días",
      indLogistics: "Logística",
      indLogisticsDesc: "Centros de distribución, almacenes y muelles de carga con tráfico mixto vehicular y peatonal.",
      indMining: "Minería",
      indMiningDesc: "Operaciones subterráneas y a cielo abierto con cargadores frontales y camiones de gran porte.",
      indConstruction: "Construcción",
      indConstructionDesc: "Obras civiles con grúas, retroexcavadoras y trabajadores de altura.",
      indOilGas: "Oil & Gas",
      indOilGasDesc: "Refinerías, plantas de proceso y poliductos donde una colisión es un evento crítico de seguridad.",
      downloadsEyebrow: "Descargas técnicas",
      downloadsTitle: "Documentación oficial UA350",
      downloadManual: "Manual de Usuario UA350",
      downloadManualDesc: "Manual completo con instrucciones de instalación, configuración de zonas y mantenimiento.",
      downloadOpen: "Abrir PDF",
      formTitle: "Solicita un Estudio de Cobertura UWB",
      formDesc: "Nuestro equipo de ingeniería evalúa la geometría de tu sitio y dimensiona la red SafeLink en menos de 48 horas.",
      formRequirements: "Sitio · vehículos · peatones · zonas críticas",
      formRequirementsPh: "Tipo de operación, n° de montacargas, n° de personal, plano del sitio si está disponible...",
      formSubmit: "Solicitar estudio",
    },
    auth: {
      loginTitle: "Acceso seguro",
      loginSubtitle: "Centro de Comando IN|STALROS",
      email: "Correo corporativo",
      password: "Contraseña",
      signIn: "Iniciar sesión",
      mfaSetupTitle: "Configura tu Autenticación Multifactor",
      mfaSetupSubtitle:
        "Escanea el código QR con Google Authenticator, Authy o 1Password e ingresa el código de 6 dígitos.",
      mfaVerifyTitle: "Verificación de Identidad",
      mfaVerifySubtitle: "Ingresa el código de tu app autenticadora o solicita un código por correo.",
      code: "Código de 6 dígitos",
      verify: "Verificar",
      sendEmail: "Enviar código por correo",
      emailSent: "Código enviado a tu correo (revisa también la bandeja de spam).",
      useTotp: "Usar app autenticadora (TOTP)",
      useEmail: "Usar código por correo",
      secretLabel: "Clave secreta (alternativa manual)",
      back: "Volver",
    },
    dashboard: {
      welcome: "Bienvenido(a)",
      summary: "Resumen Operacional",
      overview: "Vista General",
      projects: "Proyectos",
      licenses: "Licencias",
      tickets: "Soporte",
      documents: "Bóveda Documental",
      notifications: "Royal Ledger",
      activeProjects: "Proyectos Activos",
      totalLicenses: "Licencias Totales",
      expiringLicenses: "Por vencer",
      openTickets: "Tickets Abiertos",
      criticalTickets: "Críticos",
      unreadNotifications: "Sin leer",
      totalDocuments: "Documentos",
      recentActivity: "Actividad Reciente",
      viewAll: "Ver todo",
      noData: "Sin datos para mostrar",
      newTicket: "Nuevo ticket",
      ticketTitle: "Título",
      ticketDescription: "Descripción",
      ticketPriority: "Prioridad",
      ticketCategory: "Categoría",
      submit: "Enviar",
      cancel: "Cancelar",
      status: "Estado",
      product: "Producto",
      version: "Versión",
      seats: "Cupos",
      expiresAt: "Vence",
      activated: "Activada",
      type: "Tipo",
      size: "Tamaño",
      uploaded: "Cargado",
      download: "Descargar",
      addComment: "Agregar comentario",
      send: "Enviar",
      markRead: "Marcar leído",
      asBuilt: "As-Built",
      latestFirmware: "Firmware más reciente",
      assetSoftwareTab: "Software (ATLAS)",
      assetHardwareTab: "Hardware / Signal Shield",
      assetPhysicalTab: "Infraestructura Física",
      assetSoftwareDesc: "Licencias activas de software ATLAS y módulos relacionados",
      assetHardwareDesc: "Equipos de blindaje, gabinetes TEMPEST y módulos Sygnal Shield",
      assetPhysicalDesc: "Cámaras, radares, lectores biométricos y sensores en sitio",
      health: "Salud",
      installedAt: "Instalado",
      serial: "Serial",
      lastService: "Último servicio",
      site: "Sitio",
      model: "Modelo",
    },
    statuses: {
      active: "Activo",
      in_progress: "En curso",
      planning: "Planificación",
      commissioning: "Puesta en marcha",
      maintenance: "Mantenimiento",
      closed: "Cerrado",
      open: "Abierto",
      waiting_client: "Esperando cliente",
      resolved: "Resuelto",
      expiring: "Por vencer",
      expired: "Vencido",
      trial: "Prueba",
    },
    priorities: {
      low: "Baja", medium: "Media", high: "Alta", critical: "Crítica",
    },
    notifTypes: {
      milestone: "Hito", ticket: "Ticket", license: "Licencia",
      firmware: "Firmware", audit: "Auditoría", system: "Sistema",
    },
    countries: { Argentina: "Argentina", Chile: "Chile", Canada: "Canadá" },
    common: { language: "Idioma", region: "Región", northAmerica: "Norteamérica", southAmerica: "Sudamérica" },
    footer: {
      tag: "Inteligencia de Seguridad Integrada",
      rights: "© 2026 IN|STALROS Intelligence & Integration.",
      contact: "Nuestros canales de atención",
      whatsapp: "Chatear por WhatsApp",
      legal: "Legal",
      privacy: "Privacidad",
      terms: "Términos",
      compliance: "Cumplimiento",
    },
  },
  en: {
    nav: {
      products: "Technologies",
      atlas: "ATLAS System",
      sygnal: "Sygnal Shield",
      integrations: "Integrations",
      sectors: "Sectors",
      armor: "Electronic Armor",
      forensic: "Digital Forensics",
      footprint: "Global Footprint",
      portal: "Client Center",
      login: "Sign In",
      logout: "Sign Out",
      dashboard: "Dashboard",
      sygnalPage: "Sygnal Shield",
      safelinkPage: "SafeLink",
      vault: "Sygnal Vault",
      inbox: "Inquiries Inbox",
      platforms: "Platforms",
    },
    platforms: {
      directory: "Platforms directory",
      tenant: "tenant",
      tenants: "tenants",
      cargillDesc: "ATLAS platform live · Production",
      onboardTitle: "Want your own platform?",
      onboardDesc: "Request a dedicated tenant for your organization",
    },
    landing: {
      eyebrow: "Integrated Security Intelligence",
      heroTitle: "Raising the Bar for Industrial Security & Integration",
      heroSubtitle:
        "Comprehensive operational intelligence and asset protection solutions at a global scale. We design, integrate and sustain the technological backbone of critical operations across LATAM and North America. Inventors and creators of ATLAS and Sygnal Shield.",
      ctaPrimary: "Enter Client Center",
      ctaSecondary: "Explore technologies",
      stat1: "Protected sites",
      stat2: "24/7 operations",
      stat3: "Native integrations",
      stat4: "Active countries",
      productsEyebrow: "Proprietary Ecosystem",
      productsTitle: "Three pillars for a singular security posture",
      atlasTitle: "ATLAS System: Operational Control & Asset Intelligence",
      atlasDesc:
        "Industrial maintenance management and traceability via NFC technology, without dependency on constant connectivity.",
      atlasFeat1: "NFC Traceability: unambiguous in-field asset identification",
      atlasFeat2: "Smart Checklists: clear, safe processes backed by digital evidence",
      atlasFeat3: "Predictive Analysis: detects critical failures before operational downtime",
      atlasFeat4: "Real Efficiency: −30% operational costs · +99% maintenance visibility",
      sygnalTitle: "Sygnal Shield",
      sygnalDesc:
        "Electromagnetic protection and spectrum security for infrastructure where a compromised signal is not an option.",
      sygnalFeat1: "EMC/EMP shielding",
      sygnalFeat2: "Spectrum monitoring",
      sygnalFeat3: "RF hardening",
      integTitle: "Custom Integrations",
      integDesc:
        "Physical infrastructure, perimeter radar, and biometric access control — orchestrated as a single security OS.",
      integFeat1: "Magos Radar",
      integFeat2: "Kantech / Lenel biometrics",
      integFeat3: "Physical infrastructure",
      safelinkEyebrow: "IoT Proximity Safety",
      safelinkTitle: "SafeLink (UA350) — UWB Proximity Alert System",
      safelinkDesc:
        "Vehicle-to-pedestrian collision prevention on industrial sites. High-fidelity Ultra-Wideband localization with configurable Alert and Alarm zones (0–100 m).",
      safelinkFeat1: "UWB precision in complex environments",
      safelinkFeat2: "Configurable Alert/Alarm zones 0–100 m",
      safelinkFeat3: "Industrial-grade IP65/IP67",
      sygnalCardEyebrow: "Accessory line · Sygnal Shield",
      sygnalCardTitle: "Sygnal Shield Card Sleeve: Portable EM Shielding",
      sygnalCardDesc:
        "Advanced protection for RFID and NFC cards. Acts as a portable Faraday cage, blocking any unauthorized read attempt or cloning of corporate access credentials.",
      sygnalCardFeat1: "Total blocking of NFC, RFID HF and RFID UHF",
      sygnalCardFeat2: "BCRA Resolution A 7724 · ISO/IEC 14443 compliant",
      sygnalCardFeat3: "ASTM D1894 · daily use with no shielding degradation",
      sygnalCardCta: "Explore the Sygnal line",
      trustEyebrow: "Social Proof",
      trustTitle: "Trusted by Global Leaders",
      trustDesc:
        "Our integrated intelligence solutions operate inside the most critical infrastructures of multiple enterprises across LATAM and North America.",
      radarEyebrow: "Perimeter Detection",
      radarTitle: "Military-Grade Radar Solutions",
      radarDesc:
        "Long-range, high-precision perimeter detection. Native integration for 24/7 monitoring regardless of weather or lighting conditions.",
      radarFeat1: "Long range with sub-meter resolution",
      radarFeat2: "24/7 all-weather operation",
      radarFeat3: "Native ATLAS C&C integration",
      radarFeat4: "Configurable 360° sector coverage",
      footprintEyebrow: "Global Footprint",
      footprintTitle: "We operate where reliability is non-negotiable",
      ctaTitle: "Ready for an operation with full visibility?",
      ctaDesc:
        "Enter the IN|STALROS Command Center and orchestrate your ATLAS, Sygnal Shield, and integrations from a single pane.",
      sectorsEyebrow: "Critical Sectors",
      sectorsTitle: "Where failure is not an option",
      sectorsDesc: "We design security postures calibrated for the sectors where availability and operational integrity are the business itself.",
      sectorPortsTitle: "Ports & Airports",
      sectorPortsDesc: "Perimeter surveillance, dock and runway control, AI video analytics for intrusion detection and operational traceability.",
      sectorOilTitle: "Oil & Gas — Refineries",
      sectorOilDesc: "ATEX-compliant facility protection, thermal monitoring, and early event detection in process plants and pipelines.",
      sectorMiningTitle: "Mining",
      sectorMiningDesc: "High-altitude remote operations, biometric access control for tunnels, perimeter radar for pits and open mines.",
      sectorGovTitle: "Government Infrastructure",
      sectorGovDesc: "Strategic buildings, borders and prisons — C&C solutions with compliance, electronic shielding, and chain of custody.",
      armorEyebrow: "Strategic Shielding",
      armorTitle: "Electronic Armor & Signal Shielding",
      armorDesc:
        "We extend Sygnal Shield's physical capabilities with a hardware portfolio: custom Faraday cages, TEMPEST cabinets, EMP/HEMP shielding, RF windows, and military-grade enclosures for server rooms and SCIF facilities.",
      armorPoint1: "Faraday cages & TEMPEST cabinets",
      armorPoint2: "EMP / HEMP attenuation up to 100 dB",
      armorPoint3: "Certified SCIF facilities",
      armorPoint4: "RF-shielded windows and doors",
      forensicEyebrow: "Digital Forensics",
      forensicTitle: "Forensic Informatics & Digital Investigations",
      forensicDesc:
        "Dedicated digital forensics team with consolidated expertise in the Argentine and Chilean markets. Forensic acquisition and analysis under chain of custody, judicial expert reports, evidence recovery, and incident response.",
      forensicPoint1: "Forensic acquisition (FTK, EnCase, X-Ways)",
      forensicPoint2: "Certified chain of custody",
      forensicPoint3: "Judicial expert reports AR / CL",
      forensicPoint4: "24/7 Incident Response (DFIR)",
      showcaseEyebrow: "IN|STALROS in action",
      showcaseTitle: "Real operations, visual evidence",
      showcaseDesc:
        "See how we deploy ATLAS, Sygnal Shield and integrations across critical sites in LATAM and North America. A walkthrough of field depth, use cases, and operational outcomes.",
      showcaseTag: "Showcase · 2026",
    },
    sygnal: {
      eyebrow: "Proprietary product · Sygnal Shield",
      heroTitle: "Electronically Invisible",
      heroSubtitle: "Where sensitive information must stay in, and everything else stays out. Sygnal Shield is our proprietary EM-shielding ecosystem: Faraday cages, TEMPEST cabinets, SCIF rooms, and tactical tents for field operations.",
      ctaPrimary: "Request a Spectrum Audit",
      ctaSecondary: "Download technical dossier",
      mapTitle: "Live diagnostic · How we kill the spectrum",
      mapDesc: "GSM, LTE, 5G, WiFi, Bluetooth and GPS signals are attenuated up to 100 dB at the Sygnal Shield perimeter. What enters the perimeter does not reach inside. What is processed inside does not leak outside.",
      featuresEyebrow: "Technical capabilities",
      featuresTitle: "Four product lines. One philosophy: electromagnetic silence.",
      lineFaradayTitle: "Prefabricated Faraday Cages",
      lineFaradayDesc: "Modular rooms with certified 100 dB attenuation up to 18 GHz. Rapid deployment, HVAC integration and access control.",
      lineTempestTitle: "TEMPEST Cabinets",
      lineTempestDesc: "Shielded 42U cabinets compliant with NSTISSAM TEMPEST/1-92 and NATO SDIP-27. For classified processing and Tier IV SCIF.",
      lineHempTitle: "SCIF · EMP/HEMP Rooms",
      lineHempDesc: "Protection against high-altitude electromagnetic pulse. MIL-STD-188-125-1 and IEC 61000-2-9 compliance.",
      lineTacticalTitle: "Sygnal SS-1 Tactical Tents",
      lineTacticalDesc: "Rapid deployment for field operations and mobile command. RF isolation, lightweight, foldable, MIL-STD certified.",
      galleryEyebrow: "Technical gallery",
      galleryTitle: "The physical product, the operational product",
      gal1: "Electronically Invisible — Product philosophy",
      gal2: "Prefabricated Faraday Cages on client site",
      gal3: "Sygnal SS-1 — Tactical tent deployed in operation",
      gal4: "Sygnal Shield Solutions — Applications",
      useCasesEyebrow: "Use Cases",
      useCasesTitle: "Where Sygnal Shield is the last line of defense",
      uc1Title: "Critical Server Rooms",
      uc1Desc: "Isolate classified data from TEMPEST leaks and compromised emanations.",
      uc2Title: "Field DFIR Operations",
      uc2Desc: "Acquire digital evidence with no spectrum contamination and no remote leak.",
      uc3Title: "Mobile Command & Tactical Ops",
      uc3Desc: "Isolated command communications in hostile or surveilled zones.",
      uc4Title: "SCIF & Classified Rooms",
      uc4Desc: "Certified rooms for meetings and processing of classified information.",
      specEyebrow: "Specifications",
      specTitle: "Measurable performance, not marketing",
      specAttenuation: "Attenuation",
      specStandards: "Standards",
      specRange: "Frequency range",
      specCustom: "Customization",
      specAttenuationVal: "Up to 100 dB",
      specStandardsVal: "MIL-STD-188-125 · IEEE 299 · NATO SDIP-27",
      specRangeVal: "9 kHz – 40 GHz",
      specCustomVal: "100% site-tailored",
      formEyebrow: "Spectrum Audit",
      formTitle: "Request a technical assessment for your facility",
      formDesc: "Our engineering team responds within 48 hours with a feasibility brief and preliminary sizing.",
      formName: "Full name",
      formEmail: "Corporate email",
      formCompany: "Company / Agency",
      formPhone: "Phone",
      formCountry: "Country",
      formRequirements: "Requirements · threat profile",
      formRequirementsPh: "Facility type, threat sectors, applicable standards...",
      formSubmit: "Submit request",
      formSending: "Sending...",
      formSuccess: "Request received. Our team will contact you within 48 hours.",
      formError: "Could not submit your request. Please try again in a few minutes.",
      formRateLimit: "Too many requests from your IP. Please retry in one hour.",
      formCaptchaRequired: "Please complete the captcha verification before submitting.",
      formCaptchaFailed: "Captcha verification failed. Please retry the checkbox.",
      vaultPromoTitle: "Access the Sygnal Shield Technical Vault",
      vaultPromoDesc: "Datasheets, compliance reports and firmware notes. Downloads restricted to authenticated clients.",
      vaultPromoCta: "Enter the Vault",
    },
    vault: {
      eyebrow: "Technical repository · Restricted",
      title: "Sygnal Shield Technical Vault",
      subtitle: "Datasheets, compliance reports, firmware notes and operational playbooks for Sygnal Shield clients.",
      filterAll: "All",
      filterFaraday: "Faraday",
      filterTempest: "TEMPEST",
      filterHemp: "EMP/HEMP",
      filterSpectrum: "Spectrum",
      filterTactical: "Tactical",
      attenuation: "Attenuation",
      standards: "Standards",
      version: "Version",
      noItems: "No documents in this category.",
    },
    inbox: {
      eyebrow: "Lead inbox · Admin only",
      title: "Inquiries Inbox",
      subtitle: "Triage global requests for Sygnal Shield, ATLAS and integrations. Respond within 48h SLA.",
      filterAll: "All", filterNew: "New", filterContacted: "Contacted",
      filterQualified: "Qualified", filterClosed: "Closed",
      total: "Total", requirements: "Requirements", country: "Country",
      company: "Company", phone: "Phone", received: "Received",
      markContacted: "Mark contacted", markQualified: "Qualify",
      markClosed: "Close", markNew: "Reopen",
      noInquiries: "No inquiries with this status.",
      typeSygnal: "Sygnal Shield", typeAtlas: "ATLAS",
      typeIntegration: "Integration", typeForensic: "Forensic", typeSafelink: "SafeLink", typeGeneral: "General",
    },
    safelink: {
      eyebrow: "Proprietary product · SafeLink (UA350)",
      heroTitle: "SafeLink — IoT Proximity Alert System (UWB)",
      heroSubtitle: "Advanced IoT solution with Ultra-Wideband. SafeLink judges danger level by real-time distance, triggering audio and visual alarms to prevent vehicle-to-pedestrian collisions in industrial environments.",
      ctaPrimary: "Request a UWB Coverage Study",
      ctaSecondary: "Download UA350 Manual",
      overviewEyebrow: "Hardware Architecture",
      overviewTitle: "Three critical elements. One UWB network.",
      hwBaseTitle: "Base Station UA350",
      hwBaseDesc: "Mounted horizontally on top or front of the forklift. Simultaneous detection of up to 30 wristbands.",
      hwBaseSpecs: "IP65 · 12V–48V DC · 30 tags",
      hwBraceletTitle: "Wristband SF202",
      hwBraceletDesc: "Rechargeable, worn on wrist or helmet. Vibration on entering danger zones, up to 23-day battery (8h/day).",
      hwBraceletSpecs: "IP67 · 23 days · vibration",
      hwAlarmTitle: "Alarm Light",
      hwAlarmDesc: "Adjustable 100 dB visual + audible signal to warn pedestrians at long range.",
      hwAlarmSpecs: "100 dB · LED · adjustable",
      zonesEyebrow: "Configurable Safety Zones",
      zonesTitle: "Three precise perimeters, adjustable to the centimeter",
      zone1Label: "ALARM", zone1Title: "Emergency Alarm Zone",
      zone1Desc: "Critical perimeter requiring immediate reaction. Activates light, siren and vibration.",
      zone1Range: "e.g. 0–5 m",
      zone2Label: "ALERT", zone2Title: "Pre-alarm Zone",
      zone2Desc: "Preventive warning area. Notifies pedestrian and operator.",
      zone2Range: "e.g. 5–10 m",
      zone3Label: "CAUTION", zone3Title: "Safe Zone",
      zone3Desc: "Safe operation area. System in silent monitoring.",
      zone3Range: "Beyond 10 m",
      specsEyebrow: "Main technical specifications",
      specsTitle: "Measurable performance, not marketing",
      specTech: "Network Technology", specTechVal: "UWB · 3.25 – 6.75 GHz",
      specRange: "Effective Range", specRangeVal: "0 – 100 m",
      specPrecision: "Precision", specPrecisionVal: "UWB 802.15.4a · high",
      specProtection: "Environmental Protection", specProtectionVal: "Base IP65 · Wristband IP67",
      specComm: "Auxiliary comms", specCommVal: "LoRa · 433 MHz",
      specPower: "Power", specPowerVal: "12V – 48V DC",
      industriesEyebrow: "Industries",
      industriesTitle: "Where SafeLink saves lives every day",
      indLogistics: "Logistics", indLogisticsDesc: "Distribution centers, warehouses and loading docks with mixed vehicle/pedestrian traffic.",
      indMining: "Mining", indMiningDesc: "Underground and open-pit operations with front loaders and heavy haul trucks.",
      indConstruction: "Construction", indConstructionDesc: "Civil works with cranes, excavators and elevated workers.",
      indOilGas: "Oil & Gas", indOilGasDesc: "Refineries, process plants and pipelines where a collision is a critical safety event.",
      downloadsEyebrow: "Technical downloads",
      downloadsTitle: "Official UA350 documentation",
      downloadManual: "UA350 User Manual",
      downloadManualDesc: "Full manual with installation, zone configuration and maintenance instructions.",
      downloadOpen: "Open PDF",
      formTitle: "Request a UWB Coverage Study",
      formDesc: "Our engineering team evaluates your site geometry and sizes the SafeLink network within 48 hours.",
      formRequirements: "Site · vehicles · pedestrians · critical zones",
      formRequirementsPh: "Operation type, # of forklifts, # of personnel, site plan if available...",
      formSubmit: "Submit study request",
    },
    auth: {
      loginTitle: "Secure access",
      loginSubtitle: "IN|STALROS Command Center",
      email: "Corporate email",
      password: "Password",
      signIn: "Sign in",
      mfaSetupTitle: "Set up Multi-Factor Authentication",
      mfaSetupSubtitle:
        "Scan the QR code with Google Authenticator, Authy, or 1Password and enter the 6-digit code.",
      mfaVerifyTitle: "Identity verification",
      mfaVerifySubtitle: "Enter the code from your authenticator app or request an email code.",
      code: "6-digit code",
      verify: "Verify",
      sendEmail: "Send email code",
      emailSent: "Code sent to your email (also check spam).",
      useTotp: "Use authenticator app (TOTP)",
      useEmail: "Use email code",
      secretLabel: "Secret key (manual fallback)",
      back: "Back",
    },
    dashboard: {
      welcome: "Welcome",
      summary: "Operational Summary",
      overview: "Overview",
      projects: "Projects",
      licenses: "Licenses",
      tickets: "Support",
      documents: "Document Vault",
      notifications: "Royal Ledger",
      activeProjects: "Active Projects",
      totalLicenses: "Total Licenses",
      expiringLicenses: "Expiring",
      openTickets: "Open Tickets",
      criticalTickets: "Critical",
      unreadNotifications: "Unread",
      totalDocuments: "Documents",
      recentActivity: "Recent Activity",
      viewAll: "View all",
      noData: "No data to display",
      newTicket: "New ticket",
      ticketTitle: "Title",
      ticketDescription: "Description",
      ticketPriority: "Priority",
      ticketCategory: "Category",
      submit: "Submit",
      cancel: "Cancel",
      status: "Status",
      product: "Product",
      version: "Version",
      seats: "Seats",
      expiresAt: "Expires",
      activated: "Activated",
      type: "Type",
      size: "Size",
      uploaded: "Uploaded",
      download: "Download",
      addComment: "Add comment",
      send: "Send",
      markRead: "Mark read",
      asBuilt: "As-Built",
      latestFirmware: "Latest firmware",
      assetSoftwareTab: "Software (ATLAS)",
      assetHardwareTab: "Hardware / Signal Shield",
      assetPhysicalTab: "Physical Infrastructure",
      assetSoftwareDesc: "Active ATLAS software licenses and related modules",
      assetHardwareDesc: "Shielding gear, TEMPEST cabinets and Sygnal Shield modules",
      assetPhysicalDesc: "On-site cameras, radars, biometric readers and sensors",
      health: "Health",
      installedAt: "Installed",
      serial: "Serial",
      lastService: "Last service",
      site: "Site",
      model: "Model",
    },
    statuses: {
      active: "Active", in_progress: "In progress", planning: "Planning",
      commissioning: "Commissioning", maintenance: "Maintenance", closed: "Closed",
      open: "Open", waiting_client: "Waiting client", resolved: "Resolved",
      expiring: "Expiring", expired: "Expired", trial: "Trial",
    },
    priorities: { low: "Low", medium: "Medium", high: "High", critical: "Critical" },
    notifTypes: {
      milestone: "Milestone", ticket: "Ticket", license: "License",
      firmware: "Firmware", audit: "Audit", system: "System",
    },
    countries: { Argentina: "Argentina", Chile: "Chile", Canada: "Canada" },
    common: { language: "Language", region: "Region", northAmerica: "North America", southAmerica: "South America" },
    footer: {
      tag: "Integrated Security Intelligence",
      rights: "© 2026 IN|STALROS Intelligence & Integration.",
      contact: "Our customer channels",
      whatsapp: "Chat on WhatsApp",
      legal: "Legal", privacy: "Privacy",
      terms: "Terms", compliance: "Compliance",
    },
  },
  fr: {
    nav: {
      products: "Technologies", atlas: "ATLAS System", sygnal: "Sygnal Shield",
      integrations: "Intégrations",
      sectors: "Secteurs", armor: "Blindage Électronique", forensic: "Forensique Numérique",
      footprint: "Présence Mondiale",
      portal: "Espace Client", login: "Connexion", logout: "Déconnexion", dashboard: "Tableau de bord",
      sygnalPage: "Sygnal Shield", safelinkPage: "SafeLink", vault: "Sygnal Vault", inbox: "Inquiries Inbox", platforms: "Plateformes",
    },
    platforms: {
      directory: "Annuaire des plateformes",
      tenant: "client",
      tenants: "clients",
      cargillDesc: "Plateforme ATLAS en production",
      onboardTitle: "Votre plateforme dédiée ?",
      onboardDesc: "Demandez un tenant privé pour votre organisation",
    },
    landing: {
      eyebrow: "Intelligence de Sécurité Intégrée",
      heroTitle: "Élever les Standards de Sécurité et d'Intégration Industrielle",
      heroSubtitle:
        "Solutions intégrées d'intelligence opérationnelle et de protection des actifs à l'échelle mondiale. Nous concevons, intégrons et soutenons l'épine dorsale technologique des opérations critiques en Amérique latine et en Amérique du Nord. Inventeurs et créateurs d'ATLAS et de Sygnal Shield.",
      ctaPrimary: "Accéder à l'Espace Client",
      ctaSecondary: "Explorer les technologies",
      stat1: "Sites protégés", stat2: "Opérations 24/7",
      stat3: "Intégrations natives", stat4: "Pays actifs",
      productsEyebrow: "Écosystème propriétaire",
      productsTitle: "Trois piliers pour une posture de sécurité unique",
      atlasTitle: "ATLAS System : Contrôle Opérationnel et Intelligence des Actifs",
      atlasDesc:
        "Gestion de la maintenance et traçabilité industrielle via NFC, sans dépendance à une connectivité constante.",
      atlasFeat1: "Traçabilité NFC : identification univoque de chaque actif sur le terrain",
      atlasFeat2: "Checklists Intelligentes : processus clairs avec preuves numériques",
      atlasFeat3: "Analyse Prédictive : détecte les défaillances avant les arrêts",
      atlasFeat4: "Efficacité Réelle : −30% des coûts d'exploitation · +99% de visibilité",
      sygnalTitle: "Sygnal Shield",
      sygnalDesc:
        "Protection électromagnétique et sécurité du spectre pour les infrastructures où un signal compromis n'est pas une option.",
      sygnalFeat1: "Blindage EMC/EMP", sygnalFeat2: "Surveillance du spectre", sygnalFeat3: "Renforcement RF",
      integTitle: "Intégrations sur mesure",
      integDesc: "Infrastructure physique, radar périmétrique et contrôle d'accès biométrique — orchestrés comme un seul OS de sécurité.",
      integFeat1: "Radar Magos", integFeat2: "Biométrie Kantech / Lenel", integFeat3: "Infrastructure physique",
      safelinkEyebrow: "Sécurité de Proximité IoT",
      safelinkTitle: "SafeLink (UA350) — Système d'alerte de proximité UWB",
      safelinkDesc: "Prévention des collisions véhicule-piéton sur sites industriels. Localisation Ultra-Wideband haute fidélité avec zones d'Alerte et d'Alarme configurables (0–100 m).",
      safelinkFeat1: "Précision UWB en environnements complexes",
      safelinkFeat2: "Zones Alerte/Alarme configurables 0–100 m",
      safelinkFeat3: "Robustesse industrielle IP65/IP67",
      sygnalCardEyebrow: "Ligne accessoires · Sygnal Shield",
      sygnalCardTitle: "Sygnal Shield Card Sleeve : Blindage EM Portable",
      sygnalCardDesc:
        "Protection avancée pour cartes RFID et NFC. Agit comme une cage de Faraday portable, bloquant toute lecture non autorisée ou clonage de badges d'accès.",
      sygnalCardFeat1: "Blocage total NFC, RFID HF et RFID UHF",
      sygnalCardFeat2: "Conforme BCRA A 7724 · ISO/IEC 14443",
      sygnalCardFeat3: "ASTM D1894 · usage quotidien sans dégradation",
      sygnalCardCta: "Découvrir la ligne Sygnal",
      trustEyebrow: "Social Proof",
      trustTitle: "Choisi par des leaders mondiaux",
      trustDesc:
        "Nos solutions d'intégration intelligente opèrent dans les infrastructures les plus critiques de nombreuses entreprises en Amérique latine et en Amérique du Nord.",
      radarEyebrow: "Détection périmétrique",
      radarTitle: "Solutions Radar de Grade Militaire",
      radarDesc: "Détection périmétrique longue portée et haute précision. Intégration native pour surveillance 24/7 quelles que soient les conditions météo ou d'éclairage.",
      radarFeat1: "Longue portée avec résolution submétrique",
      radarFeat2: "Opération 24/7 toutes conditions météo",
      radarFeat3: "Intégration native C&C ATLAS",
      radarFeat4: "Couverture 360° configurable par secteur",
      footprintEyebrow: "Présence mondiale",
      footprintTitle: "Nous opérons où la fiabilité n'est pas négociable",
      ctaTitle: "Prêt pour une opération avec une visibilité totale ?",
      ctaDesc: "Accédez au Centre de Commande IN|STALROS et orchestrez vos technologies depuis un seul écran.",
      sectorsEyebrow: "Secteurs Critiques",
      sectorsTitle: "Là où l'échec n'est pas une option",
      sectorsDesc: "Nous concevons des postures de sécurité calibrées pour les secteurs où la disponibilité et l'intégrité opérationnelle sont l'activité même.",
      sectorPortsTitle: "Ports & Aéroports",
      sectorPortsDesc: "Surveillance périmétrique, contrôle des quais et pistes, analytique vidéo IA pour détection d'intrusion et traçabilité.",
      sectorOilTitle: "Pétrole & Gaz — Raffineries",
      sectorOilDesc: "Protection ATEX, surveillance thermique, détection précoce d'événements dans les plants de procédé et pipelines.",
      sectorMiningTitle: "Mines",
      sectorMiningDesc: "Opérations distantes en altitude, contrôle d'accès biométrique en tunnels, radar périmétrique pour mines à ciel ouvert.",
      sectorGovTitle: "Infrastructures Gouvernementales",
      sectorGovDesc: "Bâtiments stratégiques, frontières et prisons — C&C avec conformité, blindage électronique et chaîne de possession.",
      armorEyebrow: "Blindage Stratégique",
      armorTitle: "Electronic Armor & Signal Shielding",
      armorDesc:
        "Nous étendons les capacités physiques de Sygnal Shield avec un portfolio matériel : cages de Faraday sur mesure, armoires TEMPEST, blindages EMP/HEMP, fenêtres RF et enceintes de niveau militaire pour salles serveurs et SCIF.",
      armorPoint1: "Cages de Faraday & armoires TEMPEST",
      armorPoint2: "Atténuation EMP / HEMP jusqu'à 100 dB",
      armorPoint3: "Salles SCIF certifiées",
      armorPoint4: "Fenêtres et portes blindées RF",
      forensicEyebrow: "Forensique Numérique",
      forensicTitle: "Forensic Informatics & Digital Investigations",
      forensicDesc:
        "Équipe dédiée à la forensique numérique avec expertise consolidée sur les marchés argentin et chilien. Acquisition et analyse sous chaîne de possession, expertises judiciaires, récupération de preuves et réponse à incident.",
      forensicPoint1: "Acquisition forensique (FTK, EnCase, X-Ways)",
      forensicPoint2: "Chaîne de possession certifiée",
      forensicPoint3: "Expertises judiciaires AR / CL",
      forensicPoint4: "Réponse à incident (DFIR) 24/7",
      showcaseEyebrow: "IN|STALROS en action",
      showcaseTitle: "Opérations réelles, preuves visuelles",
      showcaseDesc:
        "Découvrez comment nous déployons ATLAS, Sygnal Shield et nos intégrations sur les sites critiques d'Amérique latine et d'Amérique du Nord. Un aperçu de la profondeur du terrain, des cas d'usage et des résultats opérationnels.",
      showcaseTag: "Showcase · 2026",
    },
    sygnal: {
      eyebrow: "Produit propriétaire · Sygnal Shield",
      heroTitle: "Électroniquement Invisibles",
      heroSubtitle: "Là où l'information sensible doit rester dedans, et tout le reste dehors. Sygnal Shield est notre écosystème propriétaire de blindage électromagnétique : cages de Faraday, armoires TEMPEST, salles SCIF et tentes tactiques pour opérations terrain.",
      ctaPrimary: "Demander un Audit de Spectre",
      ctaSecondary: "Télécharger le dossier technique",
      mapTitle: "Diagnostic en direct · Comment nous tuons le spectre",
      mapDesc: "Les signaux GSM, LTE, 5G, WiFi, Bluetooth et GPS sont atténués jusqu'à 100 dB au périmètre Sygnal Shield. Ce qui entre n'arrive pas dedans. Ce qui se traite dedans ne fuit pas dehors.",
      featuresEyebrow: "Capacités techniques",
      featuresTitle: "Quatre lignes produit. Une seule philosophie : silence électromagnétique.",
      lineFaradayTitle: "Cages de Faraday Préfabriquées",
      lineFaradayDesc: "Salles modulaires avec atténuation certifiée 100 dB jusqu'à 18 GHz. Déploiement rapide, intégration HVAC et contrôle d'accès.",
      lineTempestTitle: "Armoires TEMPEST",
      lineTempestDesc: "Armoires 42U blindées, conformes NSTISSAM TEMPEST/1-92 et NATO SDIP-27. Pour traitement classifié et SCIF Tier IV.",
      lineHempTitle: "Salles SCIF · EMP/HEMP",
      lineHempDesc: "Protection contre l'impulsion électromagnétique de haute altitude. Conformité MIL-STD-188-125-1 et IEC 61000-2-9.",
      lineTacticalTitle: "Tentes Tactiques Sygnal SS-1",
      lineTacticalDesc: "Déploiement rapide pour opérations terrain et commandement mobile. Isolation RF, léger, pliable, certifié MIL-STD.",
      galleryEyebrow: "Galerie technique",
      galleryTitle: "Le produit physique, le produit opérationnel",
      gal1: "Électroniquement Invisibles — Philosophie produit",
      gal2: "Cages de Faraday préfabriquées sur site client",
      gal3: "Sygnal SS-1 — Tente tactique déployée en opération",
      gal4: "Solutions Sygnal Shield — Applications",
      useCasesEyebrow: "Cas d'usage",
      useCasesTitle: "Où Sygnal Shield est la dernière ligne de défense",
      uc1Title: "Salles serveurs critiques",
      uc1Desc: "Isoler les données classifiées des fuites TEMPEST et émanations compromises.",
      uc2Title: "Opérations DFIR de terrain",
      uc2Desc: "Acquérir des preuves numériques sans contamination de spectre ni fuite à distance.",
      uc3Title: "Commandement mobile & ops tactiques",
      uc3Desc: "Communications de commandement isolées en zones hostiles ou surveillées.",
      uc4Title: "SCIF & salles classifiées",
      uc4Desc: "Salles certifiées pour réunions et traitement d'informations classifiées.",
      specEyebrow: "Spécifications",
      specTitle: "Performance mesurable, pas du marketing",
      specAttenuation: "Atténuation",
      specStandards: "Normes",
      specRange: "Plage de fréquence",
      specCustom: "Personnalisation",
      specAttenuationVal: "Jusqu'à 100 dB",
      specStandardsVal: "MIL-STD-188-125 · IEEE 299 · NATO SDIP-27",
      specRangeVal: "9 kHz – 40 GHz",
      specCustomVal: "100% sur mesure",
      formEyebrow: "Audit de Spectre",
      formTitle: "Demandez une évaluation technique pour votre installation",
      formDesc: "Notre équipe ingénierie répond sous 48 heures avec un brief de faisabilité et un dimensionnement préliminaire.",
      formName: "Nom complet",
      formEmail: "Courriel professionnel",
      formCompany: "Entreprise / Organisme",
      formPhone: "Téléphone",
      formCountry: "Pays",
      formRequirements: "Exigences · profil de menace",
      formRequirementsPh: "Type d'installation, secteurs de menace, normes applicables...",
      formSubmit: "Envoyer la demande",
      formSending: "Envoi...",
      formSuccess: "Demande reçue. Notre équipe vous contactera sous 48 heures.",
      formError: "Impossible d'envoyer votre demande. Réessayez dans quelques minutes.",
      formRateLimit: "Trop de requêtes depuis votre IP. Réessayez dans une heure.",
      formCaptchaRequired: "Veuillez compléter la vérification captcha avant d'envoyer.",
      formCaptchaFailed: "La vérification captcha a échoué. Recochez la case.",
      vaultPromoTitle: "Accéder au Sygnal Shield Technical Vault",
      vaultPromoDesc: "Datasheets, rapports de conformité et notes firmware. Téléchargements restreints aux clients authentifiés.",
      vaultPromoCta: "Accéder au Vault",
    },
    vault: {
      eyebrow: "Référentiel technique · Restreint",
      title: "Sygnal Shield Technical Vault",
      subtitle: "Datasheets, rapports de conformité, notes firmware et playbooks opérationnels pour clients Sygnal Shield.",
      filterAll: "Tous",
      filterFaraday: "Faraday",
      filterTempest: "TEMPEST",
      filterHemp: "EMP/HEMP",
      filterSpectrum: "Spectre",
      filterTactical: "Tactique",
      attenuation: "Atténuation",
      standards: "Normes",
      version: "Version",
      noItems: "Aucun document dans cette catégorie.",
    },
    inbox: {
      eyebrow: "Boîte de leads · Admin uniquement",
      title: "Inquiries Inbox",
      subtitle: "Triage des demandes globales Sygnal Shield, ATLAS et intégrations. Répondre sous 48h SLA.",
      filterAll: "Toutes", filterNew: "Nouvelles", filterContacted: "Contactées",
      filterQualified: "Qualifiées", filterClosed: "Fermées",
      total: "Total", requirements: "Exigences", country: "Pays",
      company: "Entreprise", phone: "Téléphone", received: "Reçu",
      markContacted: "Marquer contactée", markQualified: "Qualifier",
      markClosed: "Fermer", markNew: "Rouvrir",
      noInquiries: "Aucune demande dans ce statut.",
      typeSygnal: "Sygnal Shield", typeAtlas: "ATLAS",
      typeIntegration: "Intégration", typeForensic: "Forensique", typeSafelink: "SafeLink", typeGeneral: "Général",
    },
    safelink: {
      eyebrow: "Produit propriétaire · SafeLink (UA350)",
      heroTitle: "SafeLink — Système d'alerte de proximité IoT (UWB)",
      heroSubtitle: "Solution IoT avancée Ultra-Wideband. SafeLink évalue le niveau de danger selon la distance en temps réel et déclenche des alarmes sonores et lumineuses pour éviter les collisions véhicule-piéton.",
      ctaPrimary: "Demander une étude de couverture UWB",
      ctaSecondary: "Télécharger le manuel UA350",
      overviewEyebrow: "Architecture matérielle",
      overviewTitle: "Trois éléments critiques. Un réseau UWB.",
      hwBaseTitle: "Station de base UA350",
      hwBaseDesc: "Montée horizontalement à l'avant ou sur le toit du chariot. Détection simultanée jusqu'à 30 bracelets.",
      hwBaseSpecs: "IP65 · 12V–48V DC · 30 tags",
      hwBraceletTitle: "Bracelet SF202",
      hwBraceletDesc: "Rechargeable, porté au poignet ou au casque. Vibration en zone de danger, autonomie 23 jours (8h/j).",
      hwBraceletSpecs: "IP67 · 23 jours · vibration",
      hwAlarmTitle: "Feu d'alarme",
      hwAlarmDesc: "Signal visuel et sonore réglable de 100 dB pour avertir les piétons à longue distance.",
      hwAlarmSpecs: "100 dB · LED · réglable",
      zonesEyebrow: "Zones de sécurité configurables",
      zonesTitle: "Trois périmètres précis, ajustables au centimètre",
      zone1Label: "ALARME", zone1Title: "Zone d'alarme d'urgence",
      zone1Desc: "Périmètre critique exigeant une réaction immédiate. Active lumière, sirène et vibration.",
      zone1Range: "ex. 0–5 m",
      zone2Label: "ALERTE", zone2Title: "Zone de pré-alarme",
      zone2Desc: "Zone d'avertissement préventif. Notifie le piéton et l'opérateur.",
      zone2Range: "ex. 5–10 m",
      zone3Label: "PRÉCAUTION", zone3Title: "Zone sûre",
      zone3Desc: "Zone d'opération sûre. Système en monitoring silencieux.",
      zone3Range: "Au-delà de 10 m",
      specsEyebrow: "Spécifications techniques principales",
      specsTitle: "Performance mesurable, pas du marketing",
      specTech: "Technologie réseau", specTechVal: "UWB · 3.25 – 6.75 GHz",
      specRange: "Portée effective", specRangeVal: "0 – 100 m",
      specPrecision: "Précision", specPrecisionVal: "UWB 802.15.4a · haute",
      specProtection: "Protection environnementale", specProtectionVal: "Base IP65 · Bracelet IP67",
      specComm: "Comms auxiliaires", specCommVal: "LoRa · 433 MHz",
      specPower: "Alimentation", specPowerVal: "12V – 48V DC",
      industriesEyebrow: "Industries",
      industriesTitle: "Là où SafeLink sauve des vies chaque jour",
      indLogistics: "Logistique", indLogisticsDesc: "Centres de distribution, entrepôts et quais avec trafic mixte véhicule/piéton.",
      indMining: "Mines", indMiningDesc: "Opérations souterraines et à ciel ouvert avec chargeuses et camions miniers.",
      indConstruction: "Construction", indConstructionDesc: "Travaux civils avec grues, pelleteuses et travailleurs en hauteur.",
      indOilGas: "Pétrole & Gaz", indOilGasDesc: "Raffineries, plants de procédé et pipelines où une collision est un événement critique.",
      downloadsEyebrow: "Téléchargements techniques",
      downloadsTitle: "Documentation officielle UA350",
      downloadManual: "Manuel utilisateur UA350",
      downloadManualDesc: "Manuel complet avec installation, configuration des zones et maintenance.",
      downloadOpen: "Ouvrir le PDF",
      formTitle: "Demandez une étude de couverture UWB",
      formDesc: "Notre équipe ingénierie évalue la géométrie de votre site et dimensionne le réseau SafeLink sous 48 heures.",
      formRequirements: "Site · véhicules · piétons · zones critiques",
      formRequirementsPh: "Type d'opération, nb de chariots, nb de personnel, plan du site si disponible...",
      formSubmit: "Envoyer la demande",
    },
    auth: {
      loginTitle: "Accès sécurisé", loginSubtitle: "Centre de Commande IN|STALROS",
      email: "Courriel professionnel", password: "Mot de passe", signIn: "Se connecter",
      mfaSetupTitle: "Configurez l'Authentification Multifactorielle",
      mfaSetupSubtitle: "Scannez le QR avec Google Authenticator, Authy ou 1Password et entrez le code à 6 chiffres.",
      mfaVerifyTitle: "Vérification d'identité",
      mfaVerifySubtitle: "Entrez le code de votre application ou demandez un code par courriel.",
      code: "Code à 6 chiffres", verify: "Vérifier", sendEmail: "Envoyer code par courriel",
      emailSent: "Code envoyé à votre courriel (vérifiez aussi le spam).",
      useTotp: "Utiliser l'application (TOTP)", useEmail: "Utiliser le code par courriel",
      secretLabel: "Clé secrète (saisie manuelle)", back: "Retour",
    },
    dashboard: {
      welcome: "Bienvenue", summary: "Résumé opérationnel", overview: "Aperçu",
      projects: "Projets", licenses: "Licences", tickets: "Support",
      documents: "Coffre documentaire", notifications: "Royal Ledger",
      activeProjects: "Projets actifs", totalLicenses: "Licences totales", expiringLicenses: "Bientôt expirées",
      openTickets: "Tickets ouverts", criticalTickets: "Critiques", unreadNotifications: "Non lus",
      totalDocuments: "Documents", recentActivity: "Activité récente", viewAll: "Tout voir",
      noData: "Aucune donnée", newTicket: "Nouveau ticket",
      ticketTitle: "Titre", ticketDescription: "Description", ticketPriority: "Priorité",
      ticketCategory: "Catégorie", submit: "Envoyer", cancel: "Annuler",
      status: "Statut", product: "Produit", version: "Version", seats: "Postes",
      expiresAt: "Expire", activated: "Activée", type: "Type", size: "Taille",
      uploaded: "Téléversé", download: "Télécharger",
      addComment: "Ajouter un commentaire", send: "Envoyer", markRead: "Marquer lu",
      asBuilt: "As-Built", latestFirmware: "Dernier firmware",
      assetSoftwareTab: "Logiciel (ATLAS)",
      assetHardwareTab: "Matériel / Signal Shield",
      assetPhysicalTab: "Infrastructure Physique",
      assetSoftwareDesc: "Licences ATLAS actives et modules associés",
      assetHardwareDesc: "Blindages, armoires TEMPEST et modules Sygnal Shield",
      assetPhysicalDesc: "Caméras, radars, lecteurs biométriques et capteurs sur site",
      health: "Santé", installedAt: "Installé", serial: "Série",
      lastService: "Dernier service", site: "Site", model: "Modèle",
    },
    statuses: {
      active: "Actif", in_progress: "En cours", planning: "Planification",
      commissioning: "Mise en service", maintenance: "Maintenance", closed: "Fermé",
      open: "Ouvert", waiting_client: "En attente client", resolved: "Résolu",
      expiring: "Bientôt expirée", expired: "Expirée", trial: "Essai",
    },
    priorities: { low: "Basse", medium: "Moyenne", high: "Haute", critical: "Critique" },
    notifTypes: {
      milestone: "Jalon", ticket: "Ticket", license: "Licence",
      firmware: "Firmware", audit: "Audit", system: "Système",
    },
    countries: { Argentina: "Argentine", Chile: "Chili", Canada: "Canada" },
    common: { language: "Langue", region: "Région", northAmerica: "Amérique du Nord", southAmerica: "Amérique du Sud" },
    footer: {
      tag: "Intelligence de Sécurité Intégrée",
      rights: "© 2026 IN|STALROS Intelligence & Integration.",
      contact: "Nos canaux de contact",
      whatsapp: "Discuter sur WhatsApp",
      legal: "Légal", privacy: "Confidentialité",
      terms: "Conditions", compliance: "Conformité",
    },
  },
  pt: {
    nav: {
      products: "Tecnologias", atlas: "ATLAS System", sygnal: "Sygnal Shield",
      integrations: "Integrações",
      sectors: "Setores", armor: "Blindagem Eletrônica", forensic: "Forense Digital",
      footprint: "Presença Global",
      portal: "Centro do Cliente", login: "Entrar", logout: "Sair", dashboard: "Painel",
      sygnalPage: "Sygnal Shield", safelinkPage: "SafeLink", vault: "Sygnal Vault", inbox: "Inquiries Inbox", platforms: "Plataformas",
    },
    platforms: {
      directory: "Diretório de plataformas",
      tenant: "cliente",
      tenants: "clientes",
      cargillDesc: "Plataforma ATLAS em produção",
      onboardTitle: "Sua plataforma dedicada?",
      onboardDesc: "Solicite um tenant privado para sua organização",
    },
    landing: {
      eyebrow: "Inteligência de Segurança Integrada",
      heroTitle: "Elevando os Padrões de Segurança e Integração Industrial",
      heroSubtitle:
        "Soluções integradas de inteligência operacional e proteção de ativos em escala global. Projetamos, integramos e sustentamos a espinha dorsal tecnológica de operações críticas em LATAM e América do Norte. Inventores e criadores de ATLAS e Sygnal Shield.",
      ctaPrimary: "Acessar Centro do Cliente", ctaSecondary: "Explorar tecnologias",
      stat1: "Sites protegidos", stat2: "Operações 24/7",
      stat3: "Integrações nativas", stat4: "Países ativos",
      productsEyebrow: "Ecossistema Proprietário",
      productsTitle: "Três pilares para uma postura de segurança única",
      atlasTitle: "ATLAS System: Controle Operacional e Inteligência de Ativos",
      atlasDesc:
        "Gestão de manutenção e rastreabilidade industrial via tecnologia NFC, sem dependência de conectividade constante.",
      atlasFeat1: "Rastreabilidade NFC: identificação unívoca de cada ativo em campo",
      atlasFeat2: "Checklists Inteligentes: processos claros com evidência digital",
      atlasFeat3: "Análise Preditiva: detecta falhas antes de paradas operacionais",
      atlasFeat4: "Eficiência Real: −30% custos operacionais · +99% visibilidade",
      sygnalTitle: "Sygnal Shield",
      sygnalDesc: "Proteção eletromagnética e segurança de espectro para infraestruturas onde um sinal comprometido não é uma opção.",
      sygnalFeat1: "Blindagem EMC/EMP", sygnalFeat2: "Monitoramento de Espectro", sygnalFeat3: "Hardening RF",
      integTitle: "Integrações sob medida",
      integDesc: "Infraestrutura física, radar perimétrico e controle de acesso biométrico — orquestrados como um único OS de segurança.",
      integFeat1: "Radar Magos", integFeat2: "Biometria Kantech / Lenel", integFeat3: "Infraestrutura física",
      safelinkEyebrow: "Segurança de Proximidade IoT",
      safelinkTitle: "SafeLink (UA350) — Sistema de Alerta de Proximidade UWB",
      safelinkDesc: "Prevenção de colisões veículo-pedestre em sites industriais. Localização Ultra-Wideband de alta fidelidade com zonas de Alerta e Alarme configuráveis (0–100 m).",
      safelinkFeat1: "Precisão UWB em ambientes complexos",
      safelinkFeat2: "Zonas Alerta/Alarme configuráveis 0–100 m",
      safelinkFeat3: "Robustez industrial IP65/IP67",
      sygnalCardEyebrow: "Linha de acessórios · Sygnal Shield",
      sygnalCardTitle: "Sygnal Shield Card Sleeve: Blindagem EM Portátil",
      sygnalCardDesc:
        "Proteção avançada para cartões RFID e NFC. Funciona como uma gaiola de Faraday portátil, bloqueando qualquer tentativa de leitura não autorizada ou clonagem de credenciais.",
      sygnalCardFeat1: "Bloqueio total NFC, RFID HF e RFID UHF",
      sygnalCardFeat2: "BCRA Resolução A 7724 · ISO/IEC 14443",
      sygnalCardFeat3: "ASTM D1894 · uso diário sem degradação",
      sygnalCardCta: "Conhecer a linha Sygnal",
      trustEyebrow: "Social Proof",
      trustTitle: "Confiável para Líderes Globais",
      trustDesc:
        "Nossas soluções de integração inteligente operam nas infraestruturas mais críticas de múltiplas empresas em LATAM e América do Norte.",
      radarEyebrow: "Detecção Perimetral",
      radarTitle: "Soluções de Radar de Grau Militar",
      radarDesc: "Detecção perimetral de longo alcance e alta precisão. Integração nativa para monitoramento 24/7 independente de clima ou iluminação.",
      radarFeat1: "Longo alcance com resolução submétrica",
      radarFeat2: "Operação 24/7 em todas as condições",
      radarFeat3: "Integração nativa C&C ATLAS",
      radarFeat4: "Cobertura 360° configurável por setor",
      footprintEyebrow: "Presença Global",
      footprintTitle: "Operamos onde a confiabilidade não é negociável",
      ctaTitle: "Pronto para uma operação com visibilidade total?",
      ctaDesc: "Acesse o Centro de Comando IN|STALROS e orquestre suas tecnologias num único painel.",
      sectorsEyebrow: "Setores Críticos",
      sectorsTitle: "Onde a falha não é uma opção",
      sectorsDesc: "Projetamos posturas de segurança calibradas para os setores onde a disponibilidade e a integridade operacional são o próprio negócio.",
      sectorPortsTitle: "Portos & Aeroportos",
      sectorPortsDesc: "Vigilância perimetral, controle de cais e pistas, analítica de vídeo com IA para detecção de intrusão e rastreabilidade.",
      sectorOilTitle: "Óleo & Gás — Refinarias",
      sectorOilDesc: "Proteção de instalações ATEX, monitoramento térmico e detecção precoce em plantas de processo e dutos.",
      sectorMiningTitle: "Mineração",
      sectorMiningDesc: "Operações remotas em altitude, controle biométrico em túneis, radar perimétrico em minas a céu aberto.",
      sectorGovTitle: "Infraestrutura Governamental",
      sectorGovDesc: "Edifícios estratégicos, fronteiras e prisões — C&C com conformidade, blindagem eletrônica e cadeia de custódia.",
      armorEyebrow: "Blindagem Estratégica",
      armorTitle: "Electronic Armor & Signal Shielding",
      armorDesc:
        "Estendemos as capacidades físicas do Sygnal Shield com um portfólio de hardware: gaiolas de Faraday sob medida, gabinetes TEMPEST, blindagens EMP/HEMP, janelas RF e enclosures de classe militar para salas de servidores e SCIF.",
      armorPoint1: "Gaiolas de Faraday & gabinetes TEMPEST",
      armorPoint2: "Atenuação EMP / HEMP até 100 dB",
      armorPoint3: "Salas SCIF certificadas",
      armorPoint4: "Janelas e portas RF blindadas",
      forensicEyebrow: "Forense Digital",
      forensicTitle: "Forensic Informatics & Digital Investigations",
      forensicDesc:
        "Equipe dedicada à forense digital com experiência consolidada nos mercados argentino e chileno. Aquisição e análise sob cadeia de custódia, perícias judiciais, recuperação de evidências e resposta a incidentes.",
      forensicPoint1: "Aquisição forense (FTK, EnCase, X-Ways)",
      forensicPoint2: "Cadeia de custódia certificada",
      forensicPoint3: "Perícias judiciais AR / CL",
      forensicPoint4: "Resposta a incidentes (DFIR) 24/7",
      showcaseEyebrow: "IN|STALROS em ação",
      showcaseTitle: "Operações reais, evidência visual",
      showcaseDesc:
        "Veja como implantamos ATLAS, Sygnal Shield e integrações em sites críticos da LATAM e América do Norte. Um percurso pela profundidade de campo, casos de uso e resultados operacionais.",
      showcaseTag: "Showcase · 2026",
    },
    sygnal: {
      eyebrow: "Produto Proprietário · Sygnal Shield",
      heroTitle: "Eletronicamente Invisíveis",
      heroSubtitle: "Onde a informação sensível precisa permanecer dentro, e tudo o mais ficar fora. Sygnal Shield é nosso ecossistema proprietário de blindagem eletromagnética: gaiolas de Faraday, gabinetes TEMPEST, salas SCIF e barracas táticas para operações de campo.",
      ctaPrimary: "Solicitar Auditoria de Espectro",
      ctaSecondary: "Baixar dossiê técnico",
      mapTitle: "Diagnóstico ao vivo · Como matamos o espectro",
      mapDesc: "Sinais GSM, LTE, 5G, WiFi, Bluetooth e GPS são atenuados em até 100 dB no perímetro Sygnal Shield. O que entra no perímetro não chega lá dentro. O que é processado dentro não vaza para fora.",
      featuresEyebrow: "Capacidades técnicas",
      featuresTitle: "Quatro linhas de produto. Uma única filosofia: silêncio eletromagnético.",
      lineFaradayTitle: "Gaiolas de Faraday Pré-fabricadas",
      lineFaradayDesc: "Salas modulares com atenuação certificada de 100 dB até 18 GHz. Implantação rápida, integração com HVAC e controle de acesso.",
      lineTempestTitle: "Gabinetes TEMPEST",
      lineTempestDesc: "Gabinetes 42U blindados, conformes a NSTISSAM TEMPEST/1-92 e NATO SDIP-27. Para processamento classificado e SCIF Tier IV.",
      lineHempTitle: "Salas SCIF · EMP/HEMP",
      lineHempDesc: "Proteção contra pulso eletromagnético de grande altitude. Conformidade MIL-STD-188-125-1 e IEC 61000-2-9.",
      lineTacticalTitle: "Barracas Táticas Sygnal SS-1",
      lineTacticalDesc: "Implantação rápida em operações de campo e comando móvel. Isolamento RF, leve, dobrável, certificado MIL-STD.",
      galleryEyebrow: "Galeria técnica",
      galleryTitle: "O produto físico, o produto operacional",
      gal1: "Eletronicamente Invisíveis — Filosofia de produto",
      gal2: "Gaiolas de Faraday pré-fabricadas em site cliente",
      gal3: "Sygnal SS-1 — Barraca tática implantada em operação",
      gal4: "Soluções Sygnal Shield — Aplicações",
      useCasesEyebrow: "Casos de Uso",
      useCasesTitle: "Onde Sygnal Shield é a última linha de defesa",
      uc1Title: "Salas de Servidores Críticos",
      uc1Desc: "Isolar dados classificados de vazamentos TEMPEST e emanações comprometidas.",
      uc2Title: "Operações DFIR de campo",
      uc2Desc: "Adquirir evidência digital sem contaminação de espectro nem vazamento remoto.",
      uc3Title: "Comando móvel & ops táticas",
      uc3Desc: "Comunicações de comando isoladas em zonas hostis ou vigiadas.",
      uc4Title: "SCIF & salas classificadas",
      uc4Desc: "Salas certificadas para reuniões e processamento de informação classificada.",
      specEyebrow: "Especificações",
      specTitle: "Performance mensurável, não marketing",
      specAttenuation: "Atenuação",
      specStandards: "Normas",
      specRange: "Faixa de frequência",
      specCustom: "Personalização",
      specAttenuationVal: "Até 100 dB",
      specStandardsVal: "MIL-STD-188-125 · IEEE 299 · NATO SDIP-27",
      specRangeVal: "9 kHz – 40 GHz",
      specCustomVal: "100% sob medida",
      formEyebrow: "Auditoria de Espectro",
      formTitle: "Solicite uma avaliação técnica para sua instalação",
      formDesc: "Nossa equipe de engenharia responde em 48 horas com um brief de viabilidade e dimensionamento preliminar.",
      formName: "Nome completo",
      formEmail: "E-mail corporativo",
      formCompany: "Empresa / Órgão",
      formPhone: "Telefone",
      formCountry: "País",
      formRequirements: "Requisitos · perfil de ameaça",
      formRequirementsPh: "Tipo de instalação, setores de ameaça, normas aplicáveis...",
      formSubmit: "Enviar solicitação",
      formSending: "Enviando...",
      formSuccess: "Solicitação recebida. Nossa equipe entrará em contato em menos de 48 horas.",
      formError: "Não foi possível enviar sua solicitação. Tente novamente em alguns minutos.",
      formRateLimit: "Muitas solicitações do seu IP. Tente novamente em uma hora.",
      formCaptchaRequired: "Por favor complete a verificação captcha antes de enviar.",
      formCaptchaFailed: "A verificação captcha falhou. Marque a caixa novamente.",
      vaultPromoTitle: "Acesso ao Sygnal Shield Technical Vault",
      vaultPromoDesc: "Datasheets, relatórios de conformidade e notas de firmware. Downloads restritos a clientes autenticados.",
      vaultPromoCta: "Acessar o Vault",
    },
    vault: {
      eyebrow: "Repositório técnico · Restrito",
      title: "Sygnal Shield Technical Vault",
      subtitle: "Datasheets, relatórios de conformidade, notas de firmware e playbooks operacionais para clientes Sygnal Shield.",
      filterAll: "Todos",
      filterFaraday: "Faraday",
      filterTempest: "TEMPEST",
      filterHemp: "EMP/HEMP",
      filterSpectrum: "Espectro",
      filterTactical: "Tático",
      attenuation: "Atenuação",
      standards: "Normas",
      version: "Versão",
      noItems: "Sem documentos nesta categoria.",
    },
    inbox: {
      eyebrow: "Caixa de leads · Apenas admin",
      title: "Inquiries Inbox",
      subtitle: "Triagem de solicitações globais Sygnal Shield, ATLAS e integrações. Responda em 48h SLA.",
      filterAll: "Todas", filterNew: "Novas", filterContacted: "Contatadas",
      filterQualified: "Qualificadas", filterClosed: "Fechadas",
      total: "Total", requirements: "Requisitos", country: "País",
      company: "Empresa", phone: "Telefone", received: "Recebido",
      markContacted: "Marcar contatada", markQualified: "Qualificar",
      markClosed: "Fechar", markNew: "Reabrir",
      noInquiries: "Sem solicitações neste status.",
      typeSygnal: "Sygnal Shield", typeAtlas: "ATLAS",
      typeIntegration: "Integração", typeForensic: "Forense", typeSafelink: "SafeLink", typeGeneral: "Geral",
    },
    safelink: {
      eyebrow: "Produto Proprietário · SafeLink (UA350)",
      heroTitle: "SafeLink — Sistema de Alerta de Proximidade IoT (UWB)",
      heroSubtitle: "Solução IoT avançada Ultra-Wideband. SafeLink avalia o grau de perigo pela distância em tempo real, acionando alarmes sonoros e luminosos para prevenir colisões veículo-pedestre.",
      ctaPrimary: "Solicitar Estudo de Cobertura UWB",
      ctaSecondary: "Baixar Manual UA350",
      overviewEyebrow: "Arquitetura de Hardware",
      overviewTitle: "Três elementos críticos. Uma rede UWB.",
      hwBaseTitle: "Estação Base UA350",
      hwBaseDesc: "Instalada horizontalmente no topo ou frente da empilhadeira. Detecção simultânea de até 30 braceletes.",
      hwBaseSpecs: "IP65 · 12V–48V DC · 30 tags",
      hwBraceletTitle: "Bracelete SF202",
      hwBraceletDesc: "Recarregável, no pulso ou capacete. Vibração em zonas de perigo, bateria até 23 dias (8h/dia).",
      hwBraceletSpecs: "IP67 · 23 dias · vibração",
      hwAlarmTitle: "Luz de Alarme",
      hwAlarmDesc: "Sinal visual e sonoro ajustável de 100 dB para alertar pedestres a longa distância.",
      hwAlarmSpecs: "100 dB · LED · ajustável",
      zonesEyebrow: "Zonas de Segurança Configuráveis",
      zonesTitle: "Três perímetros precisos, ajustáveis ao centímetro",
      zone1Label: "ALARME", zone1Title: "Zona de Alarme de Emergência",
      zone1Desc: "Perímetro crítico de reação imediata. Ativa luz, sirene e vibração.",
      zone1Range: "ex. 0–5 m",
      zone2Label: "ALERTA", zone2Title: "Zona de Pré-alarme",
      zone2Desc: "Área de aviso preventivo. Notifica pedestre e operador.",
      zone2Range: "ex. 5–10 m",
      zone3Label: "PRECAUÇÃO", zone3Title: "Zona Segura",
      zone3Desc: "Área de operação segura. Sistema em monitoramento silencioso.",
      zone3Range: "Acima de 10 m",
      specsEyebrow: "Especificações técnicas principais",
      specsTitle: "Performance mensurável, não marketing",
      specTech: "Tecnologia de Rede", specTechVal: "UWB · 3.25 – 6.75 GHz",
      specRange: "Alcance Efetivo", specRangeVal: "0 – 100 m",
      specPrecision: "Precisão", specPrecisionVal: "UWB 802.15.4a · alta",
      specProtection: "Proteção Ambiental", specProtectionVal: "Base IP65 · Bracelete IP67",
      specComm: "Comms auxiliares", specCommVal: "LoRa · 433 MHz",
      specPower: "Alimentação", specPowerVal: "12V – 48V DC",
      industriesEyebrow: "Indústrias",
      industriesTitle: "Onde SafeLink salva vidas todos os dias",
      indLogistics: "Logística", indLogisticsDesc: "Centros de distribuição, armazéns e docas com tráfego misto veículo/pedestre.",
      indMining: "Mineração", indMiningDesc: "Operações subterrâneas e a céu aberto com carregadeiras e caminhões fora-de-estrada.",
      indConstruction: "Construção", indConstructionDesc: "Obras civis com guindastes, escavadeiras e trabalhadores em altura.",
      indOilGas: "Óleo & Gás", indOilGasDesc: "Refinarias, plantas de processo e dutos onde uma colisão é um evento crítico de segurança.",
      downloadsEyebrow: "Downloads técnicos",
      downloadsTitle: "Documentação oficial UA350",
      downloadManual: "Manual do Usuário UA350",
      downloadManualDesc: "Manual completo com instalação, configuração de zonas e manutenção.",
      downloadOpen: "Abrir PDF",
      formTitle: "Solicite um Estudo de Cobertura UWB",
      formDesc: "Nossa equipe de engenharia avalia a geometria do seu site e dimensiona a rede SafeLink em menos de 48 horas.",
      formRequirements: "Site · veículos · pedestres · zonas críticas",
      formRequirementsPh: "Tipo de operação, nº de empilhadeiras, nº de pessoal, planta do site se disponível...",
      formSubmit: "Enviar solicitação",
    },
    auth: {
      loginTitle: "Acesso seguro", loginSubtitle: "Centro de Comando IN|STALROS",
      email: "E-mail corporativo", password: "Senha", signIn: "Entrar",
      mfaSetupTitle: "Configure a Autenticação Multifator",
      mfaSetupSubtitle: "Escaneie o QR com Google Authenticator, Authy ou 1Password e digite o código de 6 dígitos.",
      mfaVerifyTitle: "Verificação de identidade",
      mfaVerifySubtitle: "Digite o código do seu app autenticador ou solicite um código por e-mail.",
      code: "Código de 6 dígitos", verify: "Verificar", sendEmail: "Enviar código por e-mail",
      emailSent: "Código enviado ao seu e-mail (verifique também o spam).",
      useTotp: "Usar app autenticador (TOTP)", useEmail: "Usar código por e-mail",
      secretLabel: "Chave secreta (entrada manual)", back: "Voltar",
    },
    dashboard: {
      welcome: "Bem-vindo(a)", summary: "Resumo Operacional", overview: "Visão Geral",
      projects: "Projetos", licenses: "Licenças", tickets: "Suporte",
      documents: "Cofre Documental", notifications: "Royal Ledger",
      activeProjects: "Projetos Ativos", totalLicenses: "Licenças Totais", expiringLicenses: "A vencer",
      openTickets: "Tickets abertos", criticalTickets: "Críticos", unreadNotifications: "Não lidos",
      totalDocuments: "Documentos", recentActivity: "Atividade recente", viewAll: "Ver tudo",
      noData: "Sem dados", newTicket: "Novo ticket",
      ticketTitle: "Título", ticketDescription: "Descrição", ticketPriority: "Prioridade",
      ticketCategory: "Categoria", submit: "Enviar", cancel: "Cancelar",
      status: "Status", product: "Produto", version: "Versão", seats: "Vagas",
      expiresAt: "Vence", activated: "Ativada", type: "Tipo", size: "Tamanho",
      uploaded: "Enviado", download: "Baixar",
      addComment: "Adicionar comentário", send: "Enviar", markRead: "Marcar lido",
      asBuilt: "As-Built", latestFirmware: "Firmware mais recente",
      assetSoftwareTab: "Software (ATLAS)",
      assetHardwareTab: "Hardware / Signal Shield",
      assetPhysicalTab: "Infraestrutura Física",
      assetSoftwareDesc: "Licenças ATLAS ativas e módulos relacionados",
      assetHardwareDesc: "Blindagens, gabinetes TEMPEST e módulos Sygnal Shield",
      assetPhysicalDesc: "Câmeras, radares, leitores biométricos e sensores in loco",
      health: "Saúde", installedAt: "Instalado", serial: "Serial",
      lastService: "Último serviço", site: "Site", model: "Modelo",
    },
    statuses: {
      active: "Ativo", in_progress: "Em andamento", planning: "Planejamento",
      commissioning: "Comissionamento", maintenance: "Manutenção", closed: "Fechado",
      open: "Aberto", waiting_client: "Aguardando cliente", resolved: "Resolvido",
      expiring: "A vencer", expired: "Vencido", trial: "Trial",
    },
    priorities: { low: "Baixa", medium: "Média", high: "Alta", critical: "Crítica" },
    notifTypes: {
      milestone: "Marco", ticket: "Ticket", license: "Licença",
      firmware: "Firmware", audit: "Auditoria", system: "Sistema",
    },
    countries: { Argentina: "Argentina", Chile: "Chile", Canada: "Canadá" },
    common: { language: "Idioma", region: "Região", northAmerica: "América do Norte", southAmerica: "América do Sul" },
    footer: {
      tag: "Inteligência de Segurança Integrada",
      rights: "© 2026 IN|STALROS Intelligence & Integration.",
      contact: "Nossos canais de atendimento",
      whatsapp: "Conversar no WhatsApp",
      legal: "Legal", privacy: "Privacidade",
      terms: "Termos", compliance: "Conformidade",
    },
  },
};
